import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useEffect, useMemo, useState } from "react";
import { Button } from "V2.0/common/button";
import InputComponent from "V2.0/components/InputComponent";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import Joi from "joi-browser";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "V2.0/common/table";

const schema = {
  field: Joi.string().required(),
  value: Joi.string().required(),
};

function ExtractionAddField(props) {
  const { fields, handleAdd, setOpen } = props;
  const inputField = {
    field: "",
    value: false,
  };

  const { data, handleChange, validate, setError, error } = useForm(
    inputField,
    schema,
    false
  );

  const selectableFieldOptions =
    fields?.map((field, id) => {
      return {
        id: id + 1,
        label: field.parameterName,
        value: field.parameterName,
      };
    }) || [];

  const getFieldValues = (dataField) => {
    const field = fields?.find((_field) => _field.parameterName === dataField);

    if (field) {
      const { parameterType } = field;

      if (parameterType === "boolean") {
        return [
          { id: 1, value: "yes", label: "Yes" },
          { id: 2, value: "no", label: "No" },
        ];
      }

      if (parameterType === "choice") {
        const { parameterChoices } = field;

        return parameterChoices.map((choice, idx) => {
          return { id: idx + 1, value: choice, label: choice };
        });
      }
    }

    return [];
  };

  const fieldValues = useMemo(() => {
    return getFieldValues(data.field);
  }, [data.field]);

  const template = [
    {
      name: "field",
      label: "Field",
      type: "select",
      options: [
        { id: 0, label: "Select Field", value: "" },
        ...(selectableFieldOptions.length > 0 ? selectableFieldOptions : []),
      ],
    },
    {
      name: "value",
      label: "Value",
      type: "select",
      options: [{ id: 0, label: "Select Value", value: "" }, ...fieldValues],
    },
  ];

  return (
    <div className="flex flex-col gap-y-8">
      <Form
        data={data}
        handleChange={handleChange}
        template={template}
        error={error}
      />
      <div className="flex self-end gap-x-2">
        <Button outline onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button onClick={() => handleAdd(data)}>Add</Button>
      </div>
    </div>
  );
}

function ExtractedDataFilters(props) {
  const { extraction, extractedData, updateExtractedData } = props;
  const [open, setOpen] = useState(false);

  const { extractionParameters } = extraction;

  const extractionParameterFields =
    extractionParameters?.filter((parameter) => {
      const { parameterType } = parameter;
      return parameterType === "boolean" || parameterType === "choice";
    }) || [];

  const selectableFields =
    extractionParameterFields?.filter((field) => {
      const { parameterName } = field;
      return extractedData[parameterName] === undefined;
    }) || [];

  const handleAdd = (data) => {
    const { field, value } = data;
    const updatedExtractedData = {
      ...extractedData,
      [field]: value,
    };
    updateExtractedData(updatedExtractedData);

    setOpen(false);
  };

  const handleDelete = (field) => {
    const updatedExtractedData = {
      ...extractedData,
    };

    delete updatedExtractedData[field];

    updateExtractedData(updatedExtractedData);
  };

  const hideAddField = selectableFields.length === 0;

  return (
    <>
      {Object.keys(extractedData).length > 0 && (
        <Table className="mb-4">
          <TableHead>
            <TableHeader>Field</TableHeader>
            <TableHeader>Value</TableHeader>
            <TableHeader></TableHeader>
          </TableHead>
          <TableBody>
            {Object.keys(extractedData).map((field, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>{field}</TableCell>
                  <TableCell>{String(extractedData[field])}</TableCell>
                  <TableCell>
                    <Button plain onClick={() => handleDelete(field)}>
                      <TrashIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
      {!hideAddField && (
        <Button outline onClick={() => setOpen(true)}>
          <PlusIcon /> Add
        </Button>
      )}

      {open && (
        <Dialog size="md" open={true} onClose={() => setOpen(false)}>
          <DialogTitle>Add Field</DialogTitle>
          <DialogBody>
            <ExtractionAddField
              fields={selectableFields}
              handleAdd={handleAdd}
              setOpen={setOpen}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export default ExtractedDataFilters;
